import { Role } from './roles';

export enum ApplicationFeature {
  Home = 0,
  Dashboard = 1,
  Users = 2,
  Companies = 3,
  Sites = 4,
  Assets = 5,
  OrderStatus = 6,
  Proposals = 7,
  Products = 8,
  Tools = 9,
  Parts = 10,
  Documents = 11,
  Feedback = 12,
  EngineeringData = 13,
  MasterSchedule = 14,
  Projects = 15,

  AdminPage = 1000,
}

export const Features = [
  { Id: ApplicationFeature.Home, Name: 'Home' },
  { Id: ApplicationFeature.Dashboard, Name: 'Dashboard' },
  { Id: ApplicationFeature.Users, Name: 'Users' },
  { Id: ApplicationFeature.Companies, Name: 'Companies' },
  { Id: ApplicationFeature.Sites, Name: 'Sites' },
  { Id: ApplicationFeature.Assets, Name: 'Assets' },
  { Id: ApplicationFeature.OrderStatus, Name: 'Order Status' },
  { Id: ApplicationFeature.Proposals, Name: 'Proposals' },
  { Id: ApplicationFeature.Products, Name: 'Products' },
  { Id: ApplicationFeature.Tools, Name: 'Tools' },
  { Id: ApplicationFeature.EngineeringData, Name: 'Engineering Data' },
  { Id: ApplicationFeature.Parts, Name: 'Parts' },
  { Id: ApplicationFeature.Documents, Name: 'Documents' },
  { Id: ApplicationFeature.Feedback, Name: 'Feedback' },
  { Id: ApplicationFeature.MasterSchedule, Name: 'Master Schedule' },
  { Id: ApplicationFeature.Projects, Name: 'Projects' },

  { Id: ApplicationFeature.AdminPage, Name: 'Admin Page' },
];

export function FeatureHasEdit(feature: ApplicationFeature) {
  switch (feature) {
    case ApplicationFeature.Users:
    case ApplicationFeature.Feedback:
    case ApplicationFeature.Assets:
    case ApplicationFeature.EngineeringData:
    case ApplicationFeature.MasterSchedule:
    case ApplicationFeature.Projects:
      return true;
    default:
      return false;
  }
}

export function FeatureHasCustomPermission(feature: ApplicationFeature) {
  switch (feature) {
    case ApplicationFeature.Feedback:
      return true;
    default:
      return false;
  }
}

export function CanViewByDefault(feature: ApplicationFeature, role: Role) {
  switch (feature) {
    case ApplicationFeature.Home:
      return true;
    case ApplicationFeature.Dashboard:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Users:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Companies:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Sites:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Assets:
      return role >= Role.DevAdmin;
    case ApplicationFeature.OrderStatus:
      return (
        role >= Role.ExternalSales &&
        role != Role.InternalSales &&
        role != Role.InternalSupport &&
        role != Role.InternalAdmin
      );
    case ApplicationFeature.Proposals:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Products:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Tools:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Parts:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Documents:
      return role >= Role.Customer;
    case ApplicationFeature.Feedback:
      return role >= Role.InternalSales;
    case ApplicationFeature.EngineeringData:
      return role >= Role.DevAdmin;
    case ApplicationFeature.MasterSchedule:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Projects:
      return role >= Role.DevAdmin;
    case ApplicationFeature.AdminPage:
      return role === Role.DevAdmin;
  }

  return false;
}

export function CanEditByDefault(feature: ApplicationFeature, role: Role) {
  switch (feature) {
    case ApplicationFeature.Home:
      return true;
    case ApplicationFeature.Dashboard:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Users:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Companies:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Sites:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Assets:
      return role >= Role.DevAdmin;
    case ApplicationFeature.OrderStatus:
      return role >= Role.ExternalSales;
    case ApplicationFeature.Proposals:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Products:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Tools:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Parts:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Documents:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Feedback:
      return role >= Role.InternalAdmin;
    case ApplicationFeature.EngineeringData:
      return role >= Role.DevAdmin;
    case ApplicationFeature.MasterSchedule:
      return role >= Role.DevAdmin;
    case ApplicationFeature.Projects:
      return role >= Role.DevAdmin;
    case ApplicationFeature.AdminPage:
      return role === Role.DevAdmin;
  }
  return false;
}
